﻿import { initNotifications } from './customKendoErrorHandler.js';

$(document).ready(function () {
    initNotifications();
});